export default {
  list: { lazy: () => import('./PaymentMethods'), component: 'PaymentMethodList' },
  create: null,
  edit: { lazy: () => import('./PaymentMethods'), component: 'PaymentMethodEdit' },
}
